module.exports = __webpack_public_path__ + "img/04北京绩效.ee99e0da.png";